import { render, staticRenderFns } from "./BiocharAnalysisSummary.vue?vue&type=template&id=3de55fbe&scoped=true&"
import script from "./BiocharAnalysisSummary.vue?vue&type=script&lang=js&"
export * from "./BiocharAnalysisSummary.vue?vue&type=script&lang=js&"
import style0 from "./BiocharAnalysisSummary.vue?vue&type=style&index=0&id=3de55fbe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de55fbe",
  null
  
)

export default component.exports